<template>
  <div class="ui-input" :class="{ 'ui-input--error': error, 'ui-input--valid': valid, 'ui-input--disabled': disabled }">
    <input
      class="ui-input__control"
      v-bind="$attrs"
      :id="id"
      :type="type === 'number' ? 'text' : type"
      :inputmode="type === 'number' ? 'numeric' : null"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script>
export default {
  name: 'UiInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput(event) {
      const normalizedValue = this.normalizeValue(event.target.value)

      if (event.target.value !== normalizedValue) {
        event.target.value = normalizedValue
      }

      this.$emit('input', normalizedValue)
    },
    normalizeValue(value) {
      if (this.type === 'number') return value.replace(/\D/g, '')
      return value
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.ui-input
  position: relative

  &__control
    width: 100%
    min-height: 48px
    padding: 0 16px
    border: var(--field-border-width, 1px) solid var(--field-border-color, #C8C8C8)
    border-radius: 4px
    transition: border .2s

    &::placeholder
      color: var(--field-placeholder-color, $gray-text)

  &--error &__control
    border: var(--field-error-border-width, 1px) solid var(--field-error-border-color, $error)

  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none

    .ui-input__control
      background-color: var(--field-disabled-bg-color, #ededed)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/UiInput.vue